import React, { FC } from 'react';

import { Icon } from '@rbilabs/components-library';

import { ToastTypeLogo } from './toast-type-logo';
import { Close, Container, Message, MessageContainer, Wrapper } from './toast.styled';
import { IToastViewProps } from './types';

export const ToastView: FC<IToastViewProps> = ({ message: label, type, closeToast }) => (
  <Wrapper type={type}>
    <Container>
      <MessageContainer>
        <ToastTypeLogo type={type} />
        <Message>{label}</Message>
      </MessageContainer>
      <Close data-testid="closeToast" onClick={closeToast}>
        <Icon color="white" icon="close" height="2.25rem" width="2.25rem" />
      </Close>
    </Container>
  </Wrapper>
);
